// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"index-module--wrapper--1yE-i","contact":"index-module--contact--1t6Ht"};